export default __webpack_public_path__ + "static/media/5.245e17ff.jpg";